"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BasisTheoryEncryption = void 0;

var _EncryptionService = require("./services/EncryptionService");

var _ProviderKeyService = require("./services/ProviderKeyService");

var _utils = require("./utils");

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

class BasisTheoryEncryption {
  constructor() {
    _defineProperty(this, "_encryptionService", void 0);

    _defineProperty(this, "_providerKeyService", void 0);
  }

  init(providers) {
    this.loadEncryption(providers);
    return Promise.resolve(this);
  }

  loadEncryption(providers) {
    const {
      aesEncryptionServices,
      encryptionFactories,
      providerKeyFactories
    } = providers.reduce(( // eslint-disable-next-line @typescript-eslint/no-shadow
    {
      aesEncryptionServices,
      encryptionFactories,
      providerKeyFactories
    }, provider) => ({
      aesEncryptionServices: [...aesEncryptionServices, ...[provider.aesEncryptionService]],
      encryptionFactories: [...encryptionFactories, ...provider.encryptionFactories],
      providerKeyFactories: [...providerKeyFactories, ...provider.providerKeyFactories]
    }), {
      aesEncryptionServices: [],
      encryptionFactories: [],
      providerKeyFactories: []
    });
    this._encryptionService = new _EncryptionService.EncryptionService(aesEncryptionServices, encryptionFactories);
    this._providerKeyService = new _ProviderKeyService.ProviderKeyService(providerKeyFactories);
  } // eslint-disable-next-line accessor-pairs


  get encryptionService() {
    return (0, _utils.assertInit)(this._encryptionService);
  } // eslint-disable-next-line accessor-pairs


  get providerKeyService() {
    return (0, _utils.assertInit)(this._providerKeyService);
  }

}

exports.BasisTheoryEncryption = BasisTheoryEncryption;